export default function useGlobalActions() {
  const updateErrorFieldByKey = (form, field, error) => (form[field].error = error);

  return {
    updateErrorFieldByKey,
  };
}
